

















































import {
    computed,
    defineComponent,
    toRefs,
    PropType,
} from '@vue/composition-api';
import { sportName as getSportName } from '@modules/eventGrid/nameExtractors';
import { getFlagByCategory } from '@src/federations/sportOffer/flags/flagMapping';
import {
    SdsBadge,
    SdsFlag,
    SdsIcon,
} from '@superbet-group/web.lib.ui-components';
import { getSportIconName } from '@core/utils/sportsOffer/sportIconMap';
import { VirtualTournament } from '@src/federations/sportOffer/competitions/types';
import Vue from 'vue';
import {
    ClickEventType,
    createClickAnalyticsPayload,
} from '@src/app/utils/clickAnalytics';
import { useHotTournamentCompetitionRedirect } from './useHotTournamentCompetitionRedirect';
import { useHotTournamentLiveEvents } from './useHotTournamentLiveEvents';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { ClickName } from '@superbet-group/product.analytics';

export default defineComponent({
    name: 'HotTournament',
    props: {
        tournament: {
            type: Object as PropType<VirtualTournament>,
            required: true,
        },
    },
    setup(props) {
        const { tournament: hotTournament } = toRefs(props);
        const { redirectToCompetition } = useHotTournamentCompetitionRedirect();
        const { liveEvents } = useHotTournamentLiveEvents(hotTournament);

        const onHotTournamentClick = (hotTournament: VirtualTournament) => {
            // @TODO(corneliu-iancu): Temporary dual analytics implementation.
            // We are currently in the process of migrating from $superAnalytics to AnalyticsSDK.
            // Both libraries are being used in parallel to validate data consistency between them.
            // DO NOT modify or remove calls to $superAnalytics until the migration is fully validated and approved.
            // Once validation is complete, $superAnalytics will be deprecated and removed.
            AnalyticsSDK.getInstance().log('click', {
                click_name: ClickName.HOT_TOURNAMENTS_CLICK,
                click: {
                    click_value: hotTournament.competitionId.toString(),
                    type: 'general_click',
                },
            });
            Vue.prototype.$superAnalytics.sendEvent(
                createClickAnalyticsPayload(ClickEventType.hotTournamentsClick, hotTournament.competitionId.toString()),
            );
            redirectToCompetition(hotTournament);
        };

        const sportIcon = computed(() => getSportIconName(props.tournament.sportId));

        return {
            sportIcon,
            liveEvents,
            getSportName,
            getFlagByCategory,
            onHotTournamentClick,
        };
    },
    components: {
        SdsFlag,
        SdsBadge,
        SdsIcon,
    },
});
